import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const HeaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    height: 18px;
    ${media.mobileDevice`

    `}
`;
export const FooterContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    margin: ${({ margin }) => margin};
    ${media.mobileDevice`
    margin: ${({ mbMargin }) => mbMargin};
    `}
`;
export const BatchLabel = styled.label`
    font-size: 11px;
    font-family: AvenirNextWorld Demi;
    color: #140f4b;
`;
export const ParkedLabel = styled.label`
    font-size: 10px;
    border: 0.5px solid #00610099;
    border-radius: 10px;
    background: #cbffd2;
    width: 50px;
    text-align: center;
    color: #008d00;
    font-family: AvenirNextWorld Demi;
    height: 18px;
    line-height:18px;
`;
export const TitleLabel = styled.label`
    font-size: 14px;
    color: #140f4b;
    font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular')};
`;
export const FooterLabel = styled.label`
    font-size: 10px;
    font-family: AvenirNextWorld Regular;
    color: ${(props) => (props.color ? props.color : '#131313')};
    margin-right: 2px;
`;
export const RedCircle = styled.div`
    height: 10px;
    width: 10px;
    background-color: #ed002a;
    border-radius: 5px;
    margin-right: 2px;
    color: #ffffff;
    font-size: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const BatchName = styled.label`
    width: ${({ width }) => (width ? width : '95px')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: -2px;
    ${media.mediumDevice`
    width: ${({ width }) => (width ? width : '170px')};
    `}
    ${media.smalDevice`
    width: 95px;
    `}
    ${media.mobileDevice`
    width : 100px;
    `}
`;

export const BatchNameNonProduct = styled.label`
    width: 125px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: -4px;
    ${media.mediumDevice`
    width : 19vw;
    `}
    ${media.smalDevice`
    width: 16vw;
    `}
    ${media.mobileDevice`
    width: 33vw;
    `}
`;

export const MultipleAllocations = styled.div`
    width: ${({ width }) => (width ? width : '267px')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: ${({ margin }) => (margin ? margin : '-6px')};

    ${media.mediumDevice`
    width: ${({ width }) => (width ? width : '346px')};
    `}
    ${media.smalDevice`
    width: ${({ width }) => (width ? width : '267px')};
    `}
    ${media.mobileDevice`
    width: ${({ mbWidth }) => (mbWidth ? mbWidth : '276px')};
    `}
`;

export const RedCircleFlex = styled.div`
    display: flex;
    margin-top: ${({ margin }) => (margin ? margin : '5px')};
`;

export const StyledDiv = styled.div`
    display: block;
    padding-left: 10px;
    margin-top: 4px;
`;
